import styled, { css } from 'styled-components';
import { H3, Text } from 'components';
import { theme, toRem } from 'design';

export const NotificationSection = styled.section`
  justify-self: center;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;

  button {
    width: ${toRem(105)};
    padding: 0;
  }
`;

interface NotificationSectionHeaderProps {
  alignCenter?: boolean;
}

export const NotificationSectionHeader = styled.header<NotificationSectionHeaderProps>`
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  margin-bottom: ${toRem(22)};

  ${({ alignCenter }) =>
    alignCenter &&
    css`
      ${H3} {
        width: 100%;
        text-align: center;
      }
    `}
`;

// Notifications
export const NotificationContentLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${toRem(22)};
  border-radius: ${toRem(11)};
  background-color: ${theme.color.neutral[100]};
  text-align: left;

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: ${toRem(33)};
  }

  > * {
    &:last-child {
      margin-left: ${toRem(22)};
    }
  }

  @media (min-width: ${theme.breakpoint.med}px) {
    > * {
      &:last-child {
        margin-left: ${toRem(33)};
      }
    }
  }
`;

export const NotificationTextLayout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  flex-grow: 1;
`;

export const NotificationDisclaimer = styled(Text).attrs({
  size: 'small',
})`
  margin-top: ${toRem(27)};
  padding: 0 ${toRem(22)};
  width: 100%;

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: 0 ${toRem(33)};
  }
`;
